import React from 'react';
import { t } from '../../../../../i18n';
import BreadCrumbs from '../../../../components/breadcrumbs/index';
import './styles.scss';

const GreetingsBlock = ({ userName }) => {
  return (
    <div className="profile-screen__greetings-wrapper">
      <div className="profile-screen__greetings-block">
        <BreadCrumbs navigationLinks={[{ url: '/', name: t('DIGITAL_COURSES.PROFILE_SCREEN.NAME'), isActive: true }]} />
        <h1>{`${t('DIGITAL_COURSES.PROFILE_SCREEN.GREETINGS')}, ${userName}!`}</h1>
        <p>{t('DIGITAL_COURSES.PROFILE_SCREEN.EXPLANATORY_TEXT')}</p>
      </div>
    </div>
  );
};

export default GreetingsBlock;
